import React, { useState } from "react";
import PageShell from "@/components/PageShell";

const TOPS = {
    headers: ["Size", "Chest (cm)", "Length (cm)", "Sleeve (cm)"],
    rows: [
        ["XS", "100", "66", "60"],
        ["S", "106", "68", "62"],
        ["M", "112", "70", "64"],
        ["L", "118", "72", "66"],
        ["XL", "124", "74", "68"],
    ],
};

const BOTTOMS = {
    headers: ["Size", "Waist (cm)", "Hip (cm)", "Inseam (cm)"],
    rows: [
        ["28", "72", "92", "78"],
        ["30", "76", "96", "80"],
        ["32", "82", "100", "80"],
        ["34", "88", "104", "82"],
        ["36", "94", "108", "82"],
    ],
};

const TABS = [
    { id: "tops", label: "Tops", data: TOPS },
    { id: "bottoms", label: "Bottoms", data: BOTTOMS },
];

const SizeGuide = () => {
    const [active, setActive] = useState("tops");
    const current = TABS.find((t) => t.id === active).data;

    return (
        <PageShell
            kicker="[How To Fit]"
            title="Size"
            accent="Guide."
            intro="Our pieces run intentionally oversized. If you're between sizes, size down for a closer fit, size up for the full architectural drape."
            testid="size-guide-page"
        >
            <section className="border-b-4 border-ink">
                <div className="px-4 md:px-8 flex flex-wrap gap-0 border-b-2 border-ink">
                    {TABS.map((t) => (
                        <button
                            key={t.id}
                            type="button"
                            onClick={() => setActive(t.id)}
                            className={`px-5 py-4 font-mono-ui text-[11px] uppercase tracking-[0.25em] border-r-2 border-ink ${
                                active === t.id
                                    ? "bg-ink text-black"
                                    : "bg-ink hover:bg-ink hover:text-black"
                            }`}
                            data-testid={`size-tab-${t.id}`}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
                <div className="p-4 md:p-8 overflow-x-auto">
                    <table className="w-full font-mono-ui text-xs border-2 border-ink">
                        <thead className="bg-ink text-black uppercase tracking-[0.2em]">
                            <tr>
                                {current.headers.map((h) => (
                                    <th key={h} className="text-left p-3 font-mono-ui text-[10px]">
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {current.rows.map((row, i) => (
                                <tr
                                    key={i}
                                    className={i % 2 === 0 ? "bg-bone" : "bg-ink"}
                                    data-testid={`size-row-${active}-${i}`}
                                >
                                    {row.map((c, j) => (
                                        <td key={j} className="p-3 border-t border-dotted border-ink/45">
                                            {j === 0 ? <strong>{c}</strong> : c}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="px-4 md:px-8 py-10 grid grid-cols-1 md:grid-cols-3 gap-6 border-b-4 border-ink">
                <Tip n="01" title="Chest" body="Measure around the fullest part of your chest, keeping the tape parallel to the floor." />
                <Tip n="02" title="Waist" body="Measure around your natural waist (above the belly button), without sucking in." />
                <Tip n="03" title="Inseam" body="Measure from the crotch to the hem of a well-fitting pair of trousers." />
            </section>
        </PageShell>
    );
};

const Tip = ({ n, title, body }) => (
    <div className="border-2 border-ink p-5 bg-bone">
        <span className="font-heading text-5xl text-hazard leading-none block">{n}</span>
        <h4 className="font-heading text-2xl uppercase mt-2">{title}</h4>
        <p className="mt-2 text-sm">{body}</p>
    </div>
);

export default SizeGuide;
